import { useMemo } from 'react';
import { ActiveFilter } from '../components/FilterPanel';
import { formatOfficialDateBR } from '../utils/officialDate';

interface UseActiveFiltersParams {
  searchQuery?: string;
  dateRange?: {
    start: string | null;
    end: string | null;
  };
  selectedItems?: Array<{
    values: string[];
    labels: { [key: string]: string };
    onRemove: (value: string) => void;
  }>;
  onClearSearch?: () => void;
  onClearDateStart?: () => void;
  onClearDateEnd?: () => void;
}

export const useActiveFilters = (params: UseActiveFiltersParams): ActiveFilter[] => {
  return useMemo(() => {
    const filters: ActiveFilter[] = [];

    // Search filter
    if (params.searchQuery) {
      filters.push({
        key: 'search',
        label: `Busca: ${params.searchQuery}`,
        onRemove: params.onClearSearch || (() => {}),
      });
    }

    // Date range filters
    if (params.dateRange?.start) {
      filters.push({
        key: 'date-start',
        label: `De: ${formatOfficialDateBR(params.dateRange.start)}`,
        onRemove: params.onClearDateStart || (() => {}),
      });
    }

    if (params.dateRange?.end) {
      filters.push({
        key: 'date-end',
        label: `Até: ${formatOfficialDateBR(params.dateRange.end)}`,
        onRemove: params.onClearDateEnd || (() => {}),
      });
    }

    // Selected items (agencies, types, etc.)
    params.selectedItems?.forEach((item, groupIndex) => {
      item.values.forEach((value) => {
        filters.push({
          key: `${groupIndex}-${value}`,
          label: item.labels[value] || value,
          onRemove: () => item.onRemove(value),
        });
      });
    });

    return filters;
  }, [params]);
};




